// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { loginInformationStyles } from "@steiner/App/Components/CustomCreateAccount/LoginInfoForm";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

loginInformationStyles.container = {
    gap: 15,
};

loginInformationStyles.fullWidthGridItem = {
    width: 12,
};

loginInformationStyles.actionsGridItem = {
    width: 12,
    css: css`
        display: flex;
        margin-top: 20px;
        justify-content: flex-end;
    `,
};

loginInformationStyles.floatingTooltipGrid = {
    width: 12,
    css: css`
        > span {
            display: inline-flex;
            width: 100%;
        }
    `,
};

loginInformationStyles.xngTooltip = {
    tooltipContent: {
        css: css`
            border-radius: 0;
            max-width: 470px;
        `,
    },
};
